import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { useDebouncedCallback } from 'use-debounce'

import TextInput from '@/components/ui/inputs/TextInput'

import { FilterState } from '../model/usePatients'

export function Searchbar({ setFilter }: { setFilter: Dispatch<SetStateAction<FilterState>> }) {
  const { t } = useTranslation()

  const debouncedOnChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = event.target.value.toLowerCase()
    setFilter((prevFilter) => ({ ...prevFilter, page: 1, searchText }))
  }, 300)

  return <TextInput defaultValue="" fullWidth onChange={debouncedOnChange} placeholder={t('offline.patients.searchPlaceholder')} />
}
